abstract class ITimeZonesDAO {
    public abstract getTimeZones(): Promise<ITimeZoneDTO[]>;
}

interface ITimeZoneDTO {
    code: string;
    offset: string;
}

interface ITimeZonesDTO {
    content: ITimeZoneDTO[];
}

export { ITimeZonesDTO, ITimeZoneDTO, ITimeZonesDAO };
